import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalController, PopoverController } from "ionic-angular";
import moment from "moment";
import { AuthService } from "../../../app/auth/auth.service";
import { marModalConfig } from "../../../configs/mar-modal-config";

@Component({
  selector: "medication-administration-record",
  templateUrl: "medication-administration-record.html",
})
export class MedicationAdministrationRecordComponent {
  @Input() isHistory: boolean = false;
  @Input() data: any = {};
  @Output() newMAR: EventEmitter<any> = new EventEmitter<any>();

  private config: any = marModalConfig;

  constructor(
    public popoverCtrl: PopoverController,
    public modalCtrl: ModalController,
    private authSvc: AuthService
  ) {}

  presentPopover(myEvent, mar) {
    let printModal = this.popoverCtrl.create(
      "MedicationNotesPage",
      { notes: mar.description },
      { cssClass: "medication-admin-notes" }
    );
    printModal.present({
      ev: myEvent,
    });
  }

  isFromToday(mar) {
    let now = moment().local().format("MM/DD/YYYY");
    let then = moment(mar.createdDatetime).format("MM/DD/YYYY");
    return now === then;
  }

  presentMarModal(): void {
    // TODO: might be a better way to load this
    this.config.inputs.medDetails.innerHTML =
      `<div>` +
      `<div class="font16px padBot4px"><span class="font16px curantisH3 " style="padding-right: 4px;">Medication:</span> ${
        this.data.name || "N/A"
      }</div>` +
      `<div class="font16px padBot4px"><span class="font16px curantisH3" style="padding-right: 4px;">Issue:</span> ${
        this.data.issue || "N/A"
      }</div>` +
      `<div class="font16px padBot4px"><span class="font16px curantisH3" style="padding-right: 4px;">PFD:</span> ${
        this.data.pfd || "N/A"
      }</div>` +
      `<div class="font16px padBot4px"><span class="font16px curantisH3" style="padding-right: 4px;">Frequency:</span> ${
        this.data.frequency || "N/A"
      }</div>` +
      `<div class="font16px padBot4px"><span class="font16px curantisH3" style="padding-right: 4px;">Route:</span> ${
        this.data.route || "N/A"
      }</div>` +
      `<div class="font16px padBot4px"><span class="font16px curantisH3" style="padding-right: 4px;">Start Date:</span> ${
        this.data.startDate || "N/A"
      }</div>` +
      `<div class="font16px padBot4px"><span class="font16px curantisH3" style="padding-right: 4px;">Discontinue Date:</span> ${
        this.data.endDate || "N/A"
      }</div>` +
      `</div>`;

    // getUser() can return null (token refresh in flight); dereferencing it
    // threw before the modal ever opened.
    const user = this.authSvc.getUser() || {};
    this.config.inputs.signature.rules.mustEqual = user.name || "";
    this.config.inputs.name.innerHTML = `<b>${user.name || ""}</b>`;

    let createMarModal = this.modalCtrl.create(
      "InputModalPage",
      { config: this.config },
      { enableBackdropDismiss: false }
    );
    createMarModal.onDidDismiss((data) => {
      if (data) {
        delete data.name;
        delete data.verification;
        delete data.medDetails;
        //delete data.signature;
        data.description = data.notes;
        data.administered = data.isAdministered === "administered";
        delete data.isAdministered;
        data.medication = this.data;
        this.newMAR.emit(data);
        // if (data !== undefined) {
        //   this.getCreateVisitModalData();
        //   this.createVisit(data);
        // }
        console.log(data);
      }
    });
    createMarModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/medication-administration-records/medication-administration-record/medication-administration-record.ts